import { AlignType } from 'common/types/styleTypes'
import { useFontSize } from './use-font-size'
import { useLineHeight } from './use-line-height'
import { useTextAlign } from './use-text-align'
import { useLetterSpacing } from './use-letter-spacing'
import { useFontFamily } from './use-font-family'
import { useFontStyle } from './use-font-style'
import { useFontWeight } from './use-font-weight'

export const useTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontFamily,
  mobileFontFamily,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
} = {}) => {
  const returnUseFontFamily = useFontFamily({
    fontFamily,
    mobileFontFamily,
  })

  const returnUseFontStyle = useFontStyle({
    fontStyle,
    mobileFontStyle,
  })

  const returnUseFontWeight = useFontWeight({
    fontWeight,
    mobileFontWeight,
  })

  const returnUseFontSize = useFontSize({
    fontSize,
    mobileFontSize,
  })

  const returnUseLineHeight = useLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
  })

  const returnUseTextAlign = useTextAlign({
    textAlign,
    mobileTextAlign,
  })

  const returnUseLetterSpacing = useLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
  })

  return {
    ...returnUseFontSize,
    ...returnUseLineHeight,
    ...returnUseTextAlign,
    ...returnUseLetterSpacing,
    ...returnUseFontFamily,
    ...returnUseFontWeight,
    ...returnUseFontStyle,
  }
}
